import { PullRequestState } from '../../../api/agent-miner-client/agent-miner-client.type';
import { blueBase, inkLight, purpleBase, redBase, skyDark } from '../../../styles/design-tokens';

const PR_STATE_COLORS: Record<string, string> = {
  [PullRequestState.Merged]: purpleBase,
  [PullRequestState.Open]: blueBase,
  [PullRequestState.Draft]: skyDark,
  [PullRequestState.Closed]: redBase,
};

const PR_STATE_ICONS: Record<string, string> = {
  [PullRequestState.Merged]: 'call_merge',
  [PullRequestState.Open]: 'radio_button_unchecked',
  [PullRequestState.Draft]: 'edit_note',
  [PullRequestState.Closed]: 'block',
};

/**
 * Resolve the dot/pill color for a PR state, falling back to a neutral grey.
 *
 * Unknown states resolve to `inkLight` (neutral grey) rather than `skyDark`,
 * which is the Draft color and would otherwise misrender them as Draft.
 *
 * @param {string} state - A PullRequestState value (or raw string).
 * @returns {string} A design-token hex color.
 */
function prStateColor(state: string): string {
  return PR_STATE_COLORS[state] ?? inkLight;
}

/**
 * Resolve the Material Symbols icon name for a PR state.
 *
 * @param {string} state - A PullRequestState value (or raw string).
 * @returns {string} A Material Symbols icon name.
 */
function prStateIcon(state: string): string {
  // `radio_button_unchecked` is the Open icon; fall back to a neutral glyph so
  // an unrecognized state does not masquerade as Open.
  return PR_STATE_ICONS[state] ?? 'help';
}

export { prStateColor, prStateIcon };
